<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>My Subjects</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="View Groups"
                        icon="pi pi-bar"
                        class="p-button-rounded p-button-text"
                        @click="viewGroups(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import { useRouter } from "vue-router";

export default {
    name:"SubjectList",
    setup(){
        const router = useRouter();
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.subject,
                data:{getSubjectList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function viewGroups(row){
            router.push({ name: 'subjectgroups', params:{sub:row.id}});
        }
        
        return {list,globalFilter, state,viewGroups}
    }
}
</script>